export default "__VITE_ASSET__kQwCXPby__"